import { getFilters } from "../../utils/commonUtils";
import { commonBaseApiSlice } from "../commonBaseApiSlice";

export const faqsApiSlice = commonBaseApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getFaqTypes: builder.mutation({
      query: () => ({
        url: `/faqs/get`,
        method: "GET",
      }),
    }),
    getFaqList: builder.mutation({
      query: (data: any) => ({
        url: `/faqs/getbyid?${getFilters(data)}`,
        method: "GET",
      }),
    }),
  }),
});


export const {
  useGetFaqTypesMutation,
  useGetFaqListMutation
} = faqsApiSlice;